import React from 'react';
import { XStack } from 'tamagui';

interface FourCardLayoutProps {
  card1?: React.ReactNode;
  card2?: React.ReactNode;
  card3?: React.ReactNode;
  card4?: React.ReactNode;
}

export const FourCardLayout: React.FC<FourCardLayoutProps> = ({ card1, card2, card3, card4 }) => (
  <XStack width="100%" height="100%" justifyContent="space-between" gap="$5">
    <XStack width="24%" justifyContent="center" alignItems="center">
      {card1 || null}
    </XStack>
    <XStack width="24%" justifyContent="center" alignItems="center">
      {card2 || null}
    </XStack>
    <XStack width="24%" justifyContent="center" alignItems="center">
      {card3 || null}
    </XStack>
    <XStack width="24%" justifyContent="center" alignItems="center">
      {card4 || null}
    </XStack>
  </XStack>
);
